import React from 'react';
import { useLocationRoute } from '../data/locationRoutes';
import locations from '../data/locations.json';
import './Footer.scss';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons';
import {faCar, faSmile} from "@fortawesome/free-solid-svg-icons";
const Footer = () => {
    const { to } = useLocationRoute();
    return (
        <footer className="footer">
            <div className="container">
                <nav className="footer-reviews" aria-label="Google reviews by location">
                    <span>Visited one of our shops?</span>
                    {locations.map(shop => <a key={shop.id} href={shop.googleReview} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faGoogle} aria-hidden="true" /> Write a {shop.city} review<span className="visually-hidden"> on Google (opens in a new tab)</span>
                    </a>)}
                </nav>
                <ul className="footer-links">
                    <li><Link to="/waynesboro">Waynesboro</Link></li>
                    <li><Link to="/staunton">Staunton</Link></li>
                    <li>
                        <a href="https://www.facebook.com/goldwrenchauto/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faFacebook}/> Facebook
                        </a>
                    </li>
                    <li>
                        <Link to={to('/contact')}><FontAwesomeIcon className="FontAwesomeIcon" icon={faSmile}/> Contact Us</Link>
                    </li>
                    <li>
                        <Link to={to('/about')}> <FontAwesomeIcon className="FontAwesomeIcon" icon={faCar} /> About</Link>
                    </li>
                    <li>
                        <Link to={to('/privacy-policy')}>Privacy Policy</Link>
                    </li>
                    <li>
                        <Link to={to('/terms')}>Terms of Use</Link>
                    </li>

                </ul>
                <p className="footer-text">© {new Date().getFullYear()} GOLDWrench Automotive. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
